"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function CreateTypedStoreProxy(store, prefix = null) {
    return {
        // _store: store,
        state: store.state,
        actions: createActionProxy(store, prefix),
        getters: createGetterProxy(store, prefix),
    };
}
exports.CreateTypedStoreProxy = CreateTypedStoreProxy;
function createActionProxy(obj, parentPath = null) {
    return new Proxy(obj, {
        get(target, key) {
            let methodpath = parentPath ? `${parentPath}/${key}` : key;
            if (target._actions[methodpath])
                return (...args) => target.dispatch(methodpath, ...args);
            return createActionProxy(obj, methodpath);
        }
    });
}
function createGetterProxy(obj, parentPath = null) {
    return new Proxy(obj, {
        get(target, key) {
            let methodpath = parentPath ? `${parentPath}/${key}` : key;
            if (target.getters[methodpath])
                return (...args) => target.getters[methodpath](...args);
            return createGetterProxy(obj, methodpath);
        }
    });
}
